import NavCertifiedTractorOn from '../../assets/svg/nav-certified_tractor-on.svg';
import NavCertifiedTractor from '../../assets/svg/nav-certified_tractor.svg';
import NavHomeOn from '../../assets/svg/nav-home-on.svg';
import NavHome from '../../assets/svg/nav-home.svg';
import NavInBoxOn from '../../assets/svg/nav-inbox-on.svg';
import NavInBox from '../../assets/svg/nav-inbox.svg';
import NavOpenMarketOn from '../../assets/svg/nav-open-market-on.svg';
import NavOpenMarket from '../../assets/svg/nav-open-market.svg';
import NavPluvaShop from '../../assets/svg/pluva-shop.svg';
import { PLUVA_SHOP_URL, pageInfo } from '../pageInfo/pageInfo.constant';

export const bottomNavigatorButtonInfo = [
  {
    link: pageInfo.homePage.path,
    defaultIcon: NavHome,
    pressedIcon: NavHomeOn,
    isExternalLink: false,
    buttonTitle: '홈',
  },
  {
    link: pageInfo.productListPage.path,
    defaultIcon: NavCertifiedTractor,
    pressedIcon: NavCertifiedTractorOn,
    isExternalLink: false,
    buttonTitle: '인증트랙터',
  },
  {
    link: PLUVA_SHOP_URL,
    defaultIcon: NavPluvaShop,
    pressedIcon: NavPluvaShop,
    isExternalLink: true,
    buttonTitle: '플루바샵',
  },
  {
    link: pageInfo.openMarketListPage.path,
    defaultIcon: NavOpenMarket,
    pressedIcon: NavOpenMarketOn,
    isExternalLink: false,
    buttonTitle: '직거래',
  },
  {
    link: pageInfo.infoListPage.path,
    defaultIcon: NavInBox,
    pressedIcon: NavInBoxOn,
    isExternalLink: false,
    buttonTitle: '정보',
  },
];
